import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import {
  CompetencyPreviewDTO,
  CompetencyRequestDTO,
} from 'src/app/private/shared/dtos/competencies.dto';
import { CompetenciesSummaryService } from 'src/app/private/shared/services/competencies/competencies-summary.service';

@Component({
  selector: 'app-onboarding-competency',
  standalone: false,
  templateUrl: './onboarding-competency.component.html',
  styleUrl: './onboarding-competency.component.scss',
})
export class OnboardingCompetencyComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() topicId: number;

  @Input() compId: number;

  subs: Subscription[] = [];

  competencyData: CompetencyRequestDTO | null;

  competency: CompetencyPreviewDTO | null;

  constructor(private competenciesSummaryService: CompetenciesSummaryService) {}

  ngOnInit() {
    this.getCompetencies();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['topicId'] || changes['compId']) {
      this.getCompetencies();
    }
  }

  getCompetencies() {
    this.competencyData = {
      rubricId: this.topicId,
      standardId: this.compId,
    };
    this.competenciesSummaryService
      .getSingleCompetency(this.competencyData)
      .subscribe({
        next: (competency) => {
          this.competency = competency.item;
        },
        error: () => {
          this.competency = null;
        },
      });
  }

  ngOnDestroy() {
    this.competency = null;
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }
  }
}
